import React from 'react';
import { Shield, Star, ChevronDown, ArrowRight, CheckCircle, Building2 } from 'lucide-react';

interface CommercialHeroSectionProps {
  onCtaClick: () => void;
}

const TRUST_BADGES = [
  { label: '4.9/5 Rating', icon: Star },
  { label: '1,800+ Leases Reviewed', icon: CheckCircle },
  { label: 'LTA 1954 Compliant', icon: Shield },
  { label: 'Secure & GDPR Compliant', icon: Shield },
];

export function CommercialHeroSection({ onCtaClick }: CommercialHeroSectionProps) {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/95 via-gray-900/85 to-gray-900/95" />
        <div className="absolute inset-0 bg-grid-pattern opacity-10" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <div className="animate-fade-in-up">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse" />
            <span className="text-white/90 text-sm font-medium">LTA 1954 Compliant &mdash; Specialist Analysis</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6">
            Commercial Lease
            <br />
            <span className="bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
              Review & Re-Write
            </span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed mb-4">
            Commercial solicitors charge &pound;1,000 - &pound;3,000+ for this service. We do it for &pound;18.75.
          </p>
          <p className="text-base text-gray-400 max-w-xl mx-auto leading-relaxed mb-10">
            Specialist commercial lease analysis at a fraction of the cost.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button
              onClick={onCtaClick}
              className="group relative bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold text-base hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <span className="inline-flex items-center gap-2">
                Get Your Review &mdash; &pound;18.75
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </button>
            <span className="text-gray-400 text-sm">Results in under 5 minutes</span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            {TRUST_BADGES.map((badge) => (
              <div key={badge.label} className="flex items-center gap-2 text-white/70">
                <badge.icon className="w-4 h-4" />
                <span className="text-sm font-medium">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce-down">
        <ChevronDown className="w-6 h-6 text-white/40" />
      </div>
    </section>
  );
}
